import React from 'react'
import styles from './Style.module.css'

const TermsAndConditionsV2 = () => {
  return (
    <div className={`${styles.termAndConditionCard}`}>
        <h2 className={`${styles.titleSub} section-title`}>Terms and Conditions</h2>
        <div className={styles.content}>
          <p>Natureland currently offers Cash Gift Vouchers only.</p>
          <ul>
          <li>Vouchers are valid for 12 months from the date of issue.</li>
<li>Cash Vouchers can be used at all Natureland outlets.</li>
<li>Voucher types are applicable for non-member rates only and non-refundable.</li>
<li>A valid 16-digit Voucher code or QR code must be presented at the time of redemption.</li>
<li>The management reserves the right to amend the terms and conditions without prior notice.</li>
<li>Voucher cannot be used for online bookings. Please call the outlet to redeem.</li>
          </ul>
        </div>
        
    </div>
  )
}

export default TermsAndConditionsV2